import { Box, Card, CardHeader, Divider, Button, Typography, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Host } from '../../../api/types/host';

import { Can } from '@/permissions/can';

interface Props {
  host: Host;
  handleOpenHostDestinationsDialog: () => void;
}

export const DestinationInfo = ({ host, handleOpenHostDestinationsDialog }: Props) => {
  const { t } = useTranslation(['host', 'common']);

  return (
    <Card variant="outlined">
      <CardHeader
        title={t('host:allowedDestinations')}
        action={
          <Can I="manageDestinations" a="Hosts" passThrough>
            {allowed => (
              <Tooltip
                title={t('common:notSufficientPermissions')}
                disableHoverListener={allowed}
                disableFocusListener={allowed}>
                <span>
                  <Button
                    sx={{ ml: 2 }}
                    onClick={handleOpenHostDestinationsDialog}
                    disabled={!allowed}>
                    {t('host:setDestination')}
                  </Button>
                </span>
              </Tooltip>
            )}
          </Can>
        }
      />
      <Divider />
      {host.destinations.map((dest, i) => (
        <Box key={dest.id}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              px: 3,
              py: 2,
            }}>
            <Typography>{dest.name}</Typography>
            <Typography>{`${t('host:floor')}: ${dest.floor}`}</Typography>
          </Box>
          {i + 1 !== host.destinations.length && <Divider />}
        </Box>
      ))}
    </Card>
  );
};
